<template>
  <div
    id="app"
    :class="insideIframe ? 'Vuecontainer' : 'background-colidee  Vuecontainer'"
  >
    <div
      v-if="dev && !insideIframe"
      style="opacity:.5;position: fixed;text-align:center;top:0;width:100%; padding:2px;background: #ca0606;z-index:999999;color:white;font-size:12px"
    >
      ATTENTION : VOUS ETES SUR LA PLATEFORME DE TEST DES OUTILS APPYPACK </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      // dev: false
    }
  },
  watch: {
    lang: {
      handler: function () {
        // console.warn()
      },
      deep: true
    },
  },
  mounted () {
    this.$store.commit('auth/SET_INSIDE_IFRAME', this.insideIframe)
  },
  computed: {
    lang () {
      console.warn(this.$store.getters["langue"]);
      return this.$store.getters["langue"]
    },
    insideIframe () {
      if (window.location !== window.parent.location) {
        return true
      } else {
        return false
      }
    },
    dev () {
      if (window && window.location && window.location.href) {
        return window.location.href.includes('dev-')
      } else {
        return false
      }
    }
  }

}
</script>

<style>
.background-colidee {
  background: white;
  height: auto;
}
.modal {
  z-index: 20000;
}
.modal-card {
  position: absolute;
  top: 50px;
}
.modal-content {
  max-width: 650px;
  overflow-y: auto !important;
  position: absolute;
  top: 50px;
}
html,
body {
  height: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin: 0;
  padding: 0;
  overflow: auto;
  background-color: #e6ecf0;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.tooltip.is-primary::before {
  border-color: #424a60 !important;
}

.tooltip.is-primary::after {
  background-color: #424a60 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue